import { gql } from "graphql-request";

/**
 * Admin GraphQL query documents — the §6.1 contract. Field selections mirror
 * `types.ts`. Names are the contract proposal; if the backend adjusts them to
 * HotChocolate conventions, update both this file and `types.ts` together.
 *
 * Every one of these hits a resolver guarded by `[Authorize(Roles = ["admin"])]`.
 */

export const ADMIN_DASHBOARD_KPIS = gql`
  query AdminDashboardKpis($from: DateTime!, $to: DateTime!) {
    adminDashboardKpis(from: $from, to: $to) {
      totalUsers
      newUsers
      newUsersTrendPct
      activeUsers30d
      subscriptions {
        trial
        active
        expired
        free
      }
    }
  }
`;

export const ADMIN_DASHBOARD_SERIES = gql`
  query AdminDashboardSeries($range: AdminTimeRange!, $from: DateTime, $to: DateTime) {
    adminDashboardSeries(range: $range, from: $from, to: $to) {
      registrations {
        label
        value
      }
      logins {
        label
        value
      }
      registrationSource {
        organic {
          label
          value
        }
        referralPlanned
      }
    }
  }
`;

export const ADMIN_IMPORT_ORIGINS = gql`
  query AdminImportOrigins($from: DateTime!, $to: DateTime!) {
    adminImportOrigins(from: $from, to: $to) {
      songs {
        chordProEditor
        openWith
        onSongImport
        songBookPlusImport
      }
      imports {
        onSongBackup
        songBookPlus
      }
    }
  }
`;

export const ADMIN_USERS = gql`
  query AdminUsers(
    $search: String
    $status: AdminSubStatus = ALL
    $sort: AdminUserSort = LOGIN
    $sortDir: SortDirection = DESC
    $skip: Int = 0
    $take: Int = 50
  ) {
    adminUsers(
      search: $search
      status: $status
      sort: $sort
      sortDir: $sortDir
      skip: $skip
      take: $take
    ) {
      totalCount
      filteredCount
      items {
        id
        name
        email
        lastLogin
        subscriptionStatus
        inTrial
        trialDaysLeft
        projectsOwned
        projectsInto
        songs
        setlists
        gigs
        songSources {
          chordProEditor
          openWith
          onSongImport
          songBookPlusImport
        }
      }
    }
  }
`;

export const ADMIN_FEATURE_USAGE = gql`
  query AdminFeatureUsage($range: AdminTimeRange!, $from: DateTime, $to: DateTime) {
    adminFeatureUsage(range: $range, from: $from, to: $to) {
      series {
        feature
        subStatus
        totalSeconds
        totalSessions
        points {
          label
          seconds
          sessions
          aggregated
        }
      }
      aggregated {
        seconds
        sessions
      }
      optOut {
        users
        optedOut
        rate
      }
      minimumCellSessions
      bucketsCollapsedToDays
    }
  }
`;
